import React from "react";
import { useInView, useCountUp } from "../../hooks/use-in-view";
import { stats } from "../../mock";

const parseStat = (v) => {
  const m = v.match(/(\d+)/);
  return { num: m ? parseInt(m[1], 10) : 0, suffix: v.replace(/\d+/, "") };
};

const StatItem = ({ s, start }) => {
  const { num, suffix } = parseStat(s.value);
  const val = useCountUp(num, 1800, start);
  return (
    <div className="text-center lg:text-left lg:border-r last:border-r-0 border-slate-200 lg:pr-6">
      <div className="font-display font-extrabold text-[26px] sm:text-[34px] lg:text-[40px] text-slate-900 leading-none">
        {val}<span className="text-teal-700">{suffix}</span>
      </div>
      <div className="mt-1.5 sm:mt-2 text-[12px] sm:text-[13.5px] text-slate-500 font-medium">{s.label}</div>
    </div>
  );
};

const Stats = () => {
  const [ref, inView] = useInView();
  return (
    <div ref={ref} className="relative max-w-7xl mx-auto px-4 sm:px-5 lg:px-6 -mt-6 lg:-mt-12 z-10">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 bg-white rounded-2xl border border-slate-200 shadow-lg p-4 sm:p-6 lg:p-8">
        {stats.map((s, i) => (<StatItem key={i} s={s} start={inView} />))}
      </div>
    </div>
  );
};

export default Stats;
